import { Link } from 'react-router-dom';

export default function Footer() {
  const handleNewsletterSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const emailInput = form.querySelector<HTMLInputElement>('input[name="email"]');
    if (emailInput) data.append('email', emailInput.value);
    fetch('https://readdy.ai/api/form/d6sna63vrivh3q8km3rg', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: data.toString(),
    }).then(() => { emailInput!.value = ''; });
  };

  return (
    <footer className="bg-[#050505] border-t border-white/8">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center cursor-pointer mb-4">
              <img
                src="https://static.readdy.ai/image/81164d3ba0f00c2a7e247a9f180c9b75/91a191cc62cc3c3c79208c8bc56002fa.png"
                alt="DBN Garage — One Stop Auto Enhancement Destination"
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              South Windsor, CT's premier XPEL-certified automotive protection studio. PPF, ceramic coating, window tint, and more — installed with precision and passion.
            </p>
            <div className="flex items-center gap-3">
              {['ri-instagram-line', 'ri-facebook-fill', 'ri-youtube-line', 'ri-google-fill'].map((icon) => (
                <a key={icon} href="https://instagram.com" rel="nofollow" target="_blank"
                  className="w-9 h-9 flex items-center justify-center border border-white/15 rounded-full text-gray-500 hover:text-white hover:border-[#FF6B35] transition-colors cursor-pointer">
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-widest text-xs mb-5">
              <a href="/services">Services</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Paint Protection Film (PPF)', href: '/services/paint-protection-film' },
                { label: 'Ceramic Coating', href: '/services/ceramic-coating' },
                { label: 'Window Tint', href: '/services/window-tint' },
                { label: 'Matte PPF / Color Change', href: '/services/matte-ppf' },
                { label: 'Windshield Protection Film', href: '/services/windshield-protection' },
                { label: 'Motorcycle PPF & Ceramic', href: '/services' },
              ].map((item) => (
                <li key={item.href}>
                  <Link to={item.href} className="text-gray-500 text-sm hover:text-[#FF6B35] transition-colors cursor-pointer">{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-widest text-xs mb-5">
              <a href="/about">Company</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'About Us', href: '/about' },
                { label: 'Gallery', href: '/gallery' },
                { label: 'Reviews', href: '/reviews' },
                { label: 'FAQ', href: '/faq' },
                { label: 'Service Areas', href: '/service-areas' },
                { label: 'Contact', href: '/contact' },
              ].map((item) => (
                <li key={item.href}>
                  <Link to={item.href} className="text-gray-500 text-sm hover:text-[#FF6B35] transition-colors cursor-pointer">{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact + newsletter */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-widest text-xs mb-5">
              <a href="/contact">Contact</a>
            </h4>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5"><i className="ri-phone-fill text-[#FF6B35] text-sm" /></span>
                <a href="tel:+18605550127" className="text-gray-500 text-sm hover:text-white transition-colors cursor-pointer">(860) 555-0127</a>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5"><i className="ri-mail-fill text-[#FF6B35] text-sm" /></span>
                <a href="mailto:info@dbngarage.com" className="text-gray-500 text-sm hover:text-white transition-colors cursor-pointer">info@dbngarage.com</a>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5"><i className="ri-map-pin-fill text-[#FF6B35] text-sm" /></span>
                <span className="text-gray-500 text-sm">South Windsor, CT &mdash; Hartford County</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5"><i className="ri-time-fill text-[#FF6B35] text-sm" /></span>
                <span className="text-gray-500 text-sm">Mon–Sat: By Appointment</span>
              </li>
            </ul>
            <p className="text-gray-600 text-xs mb-2">Get tips &amp; exclusive offers:</p>
            <form data-readdy-form onSubmit={handleNewsletterSubmit} className="flex gap-2">
              <input type="email" name="email" required placeholder="Your email"
                className="flex-1 bg-white/5 border border-white/15 rounded-lg px-3 py-2 text-sm text-white placeholder:text-gray-600 focus:outline-none focus:border-[#FF6B35] min-w-0" />
              <button type="submit"
                className="w-9 h-9 flex items-center justify-center bg-[#FF6B35] hover:bg-[#E5501A] rounded-lg text-white transition-colors cursor-pointer flex-shrink-0">
                <i className="ri-send-plane-fill text-sm" />
              </button>
            </form>
            <div className="mt-5 pt-5 border-t border-white/8">
              <p className="text-gray-600 text-xs mb-3 uppercase tracking-widest">Certified Installer</p>
              <div className="flex gap-2 flex-wrap">
                {['XPEL', 'SunTek', 'Ceramic Pro'].map((b) => (
                  <span key={b} className="bg-white/5 border border-white/10 text-white/40 text-xs font-bold px-3 py-1.5 rounded-lg">{b}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-xs">&copy; 2026 DBN Garage Auto Protection Studio. South Windsor, CT. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="text-gray-600 text-xs hover:text-gray-400 transition-colors cursor-pointer">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-600 text-xs hover:text-gray-400 transition-colors cursor-pointer">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
